// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "header[data-v-655ce8e2]{min-height:64px}", ""]);
// Exports
module.exports = exports;
